import { render, staticRenderFns } from "./AboutDeal.vue?vue&type=template&id=3a364da8&"
import script from "./AboutDeal.vue?vue&type=script&lang=js&"
export * from "./AboutDeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports